import About from "../components/sections/About";
import SideList from "../components/sections/SideList";
import Title from "../components/sections/Title";
import UsefulFor from "../components/sections/UsefulFor";
import WideContainer from "../components/WideContainer";
import CenteredRow from "../components/CenteredRow";
import { about, during, technique, usefulFor } from "../content/Metamorf";

const color = "metamorf";

function Metamorf() {
  return (
    <main className="flex-grow-1">
      <Title title="Metamorf&nbsp;érintés" color={color} />
      <About title="Metamorf érintés" paragraphs={about} color={color} />
      <SideList
        id="during"
        title="Kezelés alatt"
        secondaryText="(30-40 perc)"
        listItems={during}
        alignRight={true}
        color={color}
      />
      <UsefulFor listItems={usefulFor} color={color} />

      <WideContainer id="metamorf">
        <CenteredRow>
          <p className="mb-2">{technique}</p>
        </CenteredRow>
      </WideContainer>
    </main>
  );
}

export default Metamorf;
